module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/movimientos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exchange-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Movimientos")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/productos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Productos")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/etiquetas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Etiquetas")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-895079f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1037
// module chunks = 1